import {
  Button,
  EButtonColorVariant,
  EModalFooterVariants,
  EModalHeaderTextAlignVariant,
  EModalSize,
  EModalVariants,
  ETextStyleVariant,
  LinkButton,
  Modal,
  Text,
  useIsWindowWidthGreaterThan,
} from '@outdoorsyco/bonfire';
import { FormattedMessage, useIntl } from 'react-intl';

type TDeletePhotoModalProps = {
  isOpen: boolean;
  title: string;
  disableActions: boolean;
  onClose: () => void;
  onDeleteHandler: () => void;
};

export const DeletePhotoModal = ({
  isOpen,
  title,
  disableActions,
  onClose,
  onDeleteHandler,
}: TDeletePhotoModalProps) => {
  const intl = useIntl();
  const desktopView = useIsWindowWidthGreaterThan('sm', true);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size={EModalSize.Small}
      {...(!desktopView && { variant: EModalVariants.Bottom })}>
      <Modal.Header textAlign={EModalHeaderTextAlignVariant.Left}>
        <Text variant={ETextStyleVariant.LargeBold} className="mb-1">
          {title}
        </Text>
        <Text variant={ETextStyleVariant.MediumRegular}>
          <FormattedMessage
            defaultMessage="If you proceed, the photo will be permanently removed from your profile. You can always upload a new photo later if needed."
            id="Xr6GQ5"
          />
        </Text>
      </Modal.Header>
      <Modal.Divider />
      <Modal.Footer variant={EModalFooterVariants.Actions}>
        <LinkButton
          label={intl.formatMessage({
            defaultMessage: 'Back',
            id: 'cyR7Kh',
          })}
          onClick={onClose}
          disabled={disableActions}
        />
        <Button
          label={intl.formatMessage({ defaultMessage: 'Delete', id: 'K3r6DQ' })}
          onClick={onDeleteHandler}
          variant={EButtonColorVariant.Primary}
          disabled={disableActions}
          loading={disableActions}
        />
      </Modal.Footer>
    </Modal>
  );
};
